import React from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../components/Layout/layout";
import DonorPage from "../../components/donors";
import NewDonor from "../../components/createDonor";
import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "../../../Auth/components/ProtectedRoute";

const Donors = () => (
  <ProtectedRoute>
    <main>
    <Helmet title="Donors" />
    <Layout>
      <Routes>
        <Route path="" element={<DonorPage />} />
        <Route path="new" element={<NewDonor />} />
        <Route path=":donorId" element={<NewDonor />} />
      </Routes>
    </Layout>
    </main>
  </ProtectedRoute>
);

export default Donors;
